// src/components/LineUp/lineUpRendering.ts

export const getLineUpCanvasHeight = (ctx: CanvasRenderingContext2D): number => ctx.canvas.height;
